<template>
    <aside class="_profile-settings-column" v-if="mode !== 'yandex-pay-success'">
        <h5 class="_profile-column-title settings">Настройки</h5>
        <ul class="_profile-nav">
            <li>
                <a href="/profile#change-password">
                    <img src="@/assets/img/lk-menu-key.svg" alt="key">
                    <span>Изменить пароль</span>
                    <img class="_profile-nav-arr" src="@/assets/img/lk-menu-arrow.svg" alt="arrow">
                </a>
            </li>
            <li>
                <a href="/profile#email-control">
                    <img src="@/assets/img/lk-menu-letter.svg" alt="letter">
                    <span>Управление e-mail</span>
                    <img class="_profile-nav-arr" src="@/assets/img/lk-menu-arrow.svg" alt="arrow">
                </a>
            </li>
            <li>
                <a @click.prevent="logout" href="#">
                    <img src="@/assets/img/lk-menu-exit.svg" alt="exit">
                    <span> Выйти из аккаунта</span>
                    <img class="_profile-nav-arr" src="@/assets/img/lk-menu-arrow.svg" alt="arrow"></a>
            </li>
        </ul>
    </aside>
</template>
<script>
import request from "@/api/axios";

export default {
    props: {
        mode: {
            type: String,
            default: 'default'
        }
    },
    methods: {
        async logout() {
            await request({ action: "logout" });
            this.$router.push("/");
            this.$store.commit("logout");
        },
    }
}
</script>
<style scoped lang="scss">
._profile-settings-column {
    width: 253px;
    padding: 158px 60px 40px 0;
    border-right: 1px solid #f5f5f5;

    ._profile-column-title {
        width: 192px;
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 140%;
        color: #828282;
        border: none;
        padding-bottom: 6px;
        margin-bottom: 33px;
        border-bottom: 1px solid #828282
    }
}

@media screen and (max-width: 725px) {
    ._profile-settings-column {
        order: 3;
        width: 100%;
        flex-basis: 100%;
        border: 0;
        padding: 0;
        padding-top: 30px;

        ._profile-column-title.settings {
            padding: 0;
            margin-bottom: 20px;
            display: block;
            color: #333;
            font-size: 14px;
            font-weight: 500;
            border-bottom: 1px solid #333;
        }

        ._profile-nav {
            li {
                margin-bottom: 11px;
                height: 19px;

                a {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
}
</style>
